export type ReturnFormSections = {
  BASIC_CHECK: boolean;
  CHECK_INSIDE: boolean;
  CHECK_OUTSIDE: boolean;
  RETURNING_KEYS: boolean;
};

export const MILEAGE_ACCEPTABLE_RANGE_DIFFERENCE_IN_KM = 10000;
